export default __webpack_public_path__ + "static/media/Sash of the Blood God (nm).1aee9976.jpg";